import { api } from './client'

export type MaterialNaLista = {
  id: number

  /** 🔴 O que o assistente usa. Estável, minúscula — entra no enum do schema. */
  chave: string

  titulo: string

  /** O texto que acompanha o envio e chega ao cliente. */
  legenda: string

  nomeOriginal: string
  mime: string
  bytes: number
  ativo: boolean
  criadoEm: string
  atualizadoEm: string | null
  atualizadoPor: string | null
}

const raiz = (marca: string) => `/marcas/${encodeURIComponent(marca)}/materiais`

export const materiais = {
  listar: (marca: string) => api.get<MaterialNaLista[]>(raiz(marca)),

  /** URL da pré-visualização — exige sessão e permissão, como o resto do portal. */
  arquivo: (marca: string, id: number) =>
    `${import.meta.env.VITE_API_URL ?? ''}${raiz(marca)}/${id}/arquivo`,

  criar: (marca: string, dados: { chave: string; titulo: string; legenda: string; arquivo: File }) => {
    const corpo = new FormData()
    corpo.append('chave', dados.chave)
    corpo.append('titulo', dados.titulo)
    corpo.append('legenda', dados.legenda)
    corpo.append('arquivo', dados.arquivo)

    return api.enviarFormulario<{ id: number; chave: string }>(raiz(marca), corpo)
  },

  salvar: (marca: string, id: number, dados: { titulo: string; legenda: string; ativo: boolean }) =>
    api.put<{ id: number; chave: string; ativo: boolean }>(`${raiz(marca)}/${id}`, dados),

  apagar: (marca: string, id: number) => api.delete<void>(`${raiz(marca)}/${id}`),
}
